<template>
  <v-layout wrap align-start justify-center>
    <v-flex xs8>
      <span class="title my-auto" style="color: black">Capítulos</span>
    </v-flex>
    <v-spacer />
    <v-btn class="my-auto" small @click="ordererDialog = true" color="primary">Reordenar</v-btn>
    <v-flex xs12 class="mt-1">
      <lister
        :items="shownChapters"
        :cardBreakpoints="'xs12 sm4 md6 lg6 xl4'"
        :autosort="false"
        :emptyListMessage="'Nenhum capítulo cadastrado...'"
        searchText
        hideSearchbar
        emptyListIcon
      >
        <template v-slot:default="slotProps">
          <chapter-tile :chapter="slotProps.item" :key="slotProps.item.id" />
        </template>
      </lister>
      <v-btn fixed dark fab right bottom color="primary" @click="createChapterDialog = true">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-flex>
    <default-dialog v-model="ordererDialog">
      <orderer :originalArray="shownChapters" @arrayReordered="arrayReordered">
        <template v-slot:default="slotProps">
          <chapter-tile :chapter="slotProps.item" :key="slotProps.item.id" />
        </template>
      </orderer>
      <template slot="rightButton">
        <v-btn @click="didTapSaveReorder" :loading="loading" text>Salvar</v-btn>
      </template>
    </default-dialog>

    <create-chapter
      v-if="createChapterDialog"
      :currentChapters="shownChapters"
      @closed="createChapterDialog=false"
      @submit="createNewChapter($event)"
      :enabled="createChapterDialog"
    ></create-chapter>

    <v-snackbar v-model="snackbar" :color="snackbarColor" > {{ message }}
      <v-btn text @click="snackbar = false">Fechar</v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import {
  addChapter,
  chapterOrderRef,
  chapterCollectionRef
} from "@/firebase/api/chapter";
import DefaultDialog from "@/components/dialogs/Default";
import CreateChapter from "./Create";
import ChapterTile from "./Tile";
import Orderer from "@/components/Orderer";
import Lister from "@/components/Lister";

export default {
  components: {
    Lister,
    Orderer,
    ChapterTile,
    DefaultDialog,
    CreateChapter
  },
  data: () => ({
    chapters: [],
    snackbar: false,
    snackbarColor: '',
    message: '',
    reorderedChapters: [],
    chapterOrder: null,
    ordererDialog: false,
    createChapterDialog: false,
    loading: false,
    sucessfullMessage: (chapterTitle) => `O capítulo "${chapterTitle}" foi criado com sucesso!`,
    errorMessage: (chapterTitle) => `Erro na criação do capítulo "${chapterTitle}" na base de dados.`
  }),
  firestore: {
    chapters: chapterCollectionRef
  },
  firebase: {
    chapterOrder: chapterOrderRef
  },
  computed: {
    shownChapters() {
      if (this.chapterOrder == null) {
        return [];
      }
      let shown = this.chapters.slice();
      shown.sort(this.sortChapters);
      return shown;
    },
    sortChapters() {
      return (a, b) => {
        let indexA = this.chapterOrder.indexOf(a.id);
        let indexB = this.chapterOrder.indexOf(b.id);
        return indexA - indexB;
      };
    }
  },
  methods: {
    arrayReordered(newArray) {
      this.reorderedChapters = newArray.map(value => value.id);
    },
    didTapSaveReorder() {
      this.ordererDialog = false;
      this.$firebaseRefs.chapterOrder.set(this.reorderedChapters);
    },
    createNewChapter(chapter) {
      this.loading = true;
      addChapter(chapter).then(result => {
        const message = result ? this.sucessfullMessage : this.errorMessage
        this.message = message(chapter.title)
        this.snackbarColor = `${result ? 'green' : 'red'} darken-1`; 
        this.createChapterDialog = false;
        this.loading = false;
        this.snackbar = true;
      });
    }
  }
};
</script>